import { httpDELETE, httpGET, httpPOST, httpPUT } from '../../services/http';
import {
  Drawing,
  DrawingRevisionSummary,
  DrawingSaveResult,
  DrawingSummary,
  ProjectGeometry,
  ProjectGeometryUpdate,
} from '../../types/drawing';
import { Project } from '../../types/project';
import { DrawingDocument } from '../new-project-cad/drawingDocument';

export const drawingsApi = {
  list: async (): Promise<DrawingSummary[]> => (await httpGET('/drawings')).data,
  create: async (name: string, document: DrawingDocument | null = null): Promise<Drawing> =>
    (await httpPOST('/drawings', { name, document })).data,
  get: async (id: number): Promise<Drawing> => (await httpGET(`/drawings/${id}`)).data,
  save: async (id: number, document: DrawingDocument, baseLockKey: number): Promise<DrawingSaveResult> =>
    (await httpPUT(`/drawings/${id}`, { document, baseLockKey })).data,
  rename: async (id: number, name: string): Promise<DrawingSaveResult> =>
    (await httpPUT(`/drawings/${id}`, { name })).data,
  savePreview: async (id: number, imageBase64: string): Promise<void> => {
    await httpPUT(`/drawings/${id}/preview`, { imageBase64 });
  },
  saveReferenceImage: async (id: number, image: Blob): Promise<string> => {
    const form = new FormData();
    form.append('image', image, 'plan');
    return (await httpPUT(`/drawings/${id}/reference-image`, form)).data.referenceImageUrl;
  },
  saveSource: async (id: number, gzippedDxf: Blob): Promise<string> => {
    const form = new FormData();
    form.append('file', gzippedDxf, 'drawing.dxf.gz');
    return (await httpPUT(`/drawings/${id}/source`, form)).data.sourceUrl;
  },
  delete: async (id: number): Promise<void> => {
    await httpDELETE(`/drawings/${id}`, {});
  },
  checkpoint: async (id: number, label: string | null): Promise<DrawingRevisionSummary> =>
    (await httpPOST(`/drawings/${id}/checkpoints`, { label })).data,
  revision: async (id: number, revision: number): Promise<{ document: DrawingDocument }> =>
    (await httpGET(`/drawings/${id}/revisions/${revision}`)).data,
};

export const projectGeometryApi = {
  project: async (projectId: number): Promise<Project> => (await httpGET(`/projects/${projectId}`)).data,
  get: async (projectId: number): Promise<ProjectGeometry> => (await httpGET(`/projects/${projectId}/geometry`)).data,
  update: async (projectId: number, update: ProjectGeometryUpdate, model: File): Promise<Project> => {
    const form = new FormData();
    form.append('request', new Blob([JSON.stringify(update)], { type: 'application/json' }));
    form.append('models', model);
    return (await httpPOST(`/projects/${projectId}/geometry`, form)).data;
  },
};
